import { css } from '@emotion/react';
import ANIMATION from '../../constants/animation/index.js';
import '../../constants/breakpoints/index.js';
import '../../constants/grid/index.js';
import '../../constants/mediaQueries/index.js';
import '../../constants/boxShadows/primary.js';
import '../../constants/boxShadows/secondary.js';

var iconStyles = _ref => {
  var {
    displayInline,
    fill,
    rotate
  } = _ref;
  return /*#__PURE__*/css("display:", displayInline ? 'inline-block' : 'block', ";transform:rotate(", rotate, "deg);color:", fill, ";transition:color ", ANIMATION.defaultTiming, ",transform ", ANIMATION.defaultTiming, ";;label:iconStyles;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUU0RCIsImZpbGUiOiJzdHlsZS50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IEFOSU1BVElPTiB9IGZyb20gJy4uLy4uL2NvbnN0YW50cyc7XG5jb25zdCBpY29uU3R5bGVzID0gKHsgZGlzcGxheUlubGluZSwgZmlsbCwgcm90YXRlIH0pID0+IGNzcyBgXG4gIGRpc3BsYXk6ICR7ZGlzcGxheUlubGluZSA/ICdpbmxpbmUtYmxvY2snIDogJ2Jsb2NrJ307XG4gIHRyYW5zZm9ybTogcm90YXRlKCR7cm90YXRlfWRlZyk7XG4gIGNvbG9yOiAke2ZpbGx9O1xuICB0cmFuc2l0aW9uOiBjb2xvciAke0FOSU1BVElPTi5kZWZhdWx0VGltaW5nfSxcbiAgICB0cmFuc2Zvcm0gJHtBTklNQVRJT04uZGVmYXVsdFRpbWluZ307XG5gO1xuZXhwb3J0IGRlZmF1bHQge1xuICAgIGljb25TdHlsZXMsXG59O1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9c3R5bGUuanMubWFwIl19 */"));
};

var Style = {
  iconStyles
};

export { Style as default };
